import { useDispatch, useSelector } from 'react-redux';
import styles from '../style/submit_feedback_style.module.css'
import { submitFeedbackActions } from '../state/submit_feedback_store';
import { Button } from 'primereact/button';

const SubmitFeedbackComp = () => {

    const dispatch = useDispatch();
    const rdxSubmitFeedback = useSelector((state) => state.submitFeedback);
    const {rating, feedback, isSubmitted} = rdxSubmitFeedback;

    const handleOnClickStarRating = (value) => {
        dispatch(submitFeedbackActions.setRating(value));
    }

    const handleOnChangeFeedback = (e) => {
        dispatch(submitFeedbackActions.setFeedback(e.target.value));
    }

    const handleSubmitFeedback = () => {
        dispatch(submitFeedbackActions.setIsSubmitted(true));
    }

    if(isSubmitted){
        return (
            <div className={`bg-gradient-login ${styles.container}`}>
                <div className={styles.content}>
                    <div className={`${styles.header_container}`}>
                        <h1>Thank You for Your Feedback!</h1>
                        <p>
                        We appreciate you taking the time to share your thoughts with us. Your feedback helps us improve and provide a better experience for you. If you have any further suggestions, feel free to reach out.
                        </p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={`bg-gradient-login ${styles.container}`}>
            <div className={styles.content}>
                <div className={`${styles.header_container}`}>
                    <h1>We value your opinion</h1>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi enim sequi neque tenetur, est temporibus nisi rem. Eius inventore veniam, quo at rerum, quos, ipsa neque maiores ea esse alias.
                    </p>
                </div>
                <div className={`${styles.body_container}`}>
                    <div>
                        <div>How would you rate your overall experience?</div>
                        <div className={styles.rating_container}>
                            <button className={styles.rating_button} onClick={() => handleOnClickStarRating(1)}>
                                <i className={`pi pi-${rating >=1 ? 'star-fill' : 'star'}`}></i>
                            </button>
                            <button className={styles.rating_button} onClick={() => handleOnClickStarRating(2)}>
                                <i className={`pi pi-${rating >=2 ? 'star-fill' : 'star'}`}></i>
                            </button>
                            <button className={styles.rating_button} onClick={() => handleOnClickStarRating(3)}>
                                <i className={`pi pi-${rating >=3 ? 'star-fill' : 'star'}`}></i>
                            </button>
                            <button className={styles.rating_button} onClick={() => handleOnClickStarRating(4)}>
                                <i className={`pi pi-${rating >=4 ? 'star-fill' : 'star'}`}></i>
                            </button>
                            <button className={styles.rating_button} onClick={() => handleOnClickStarRating(5)}>
                                <i className={`pi pi-${rating >=5 ? 'star-fill' : 'star'}`}></i>
                            </button>
                        </div>
                    </div>
                    <div className={styles.textarea_container}>
                        <label htmlFor="textarea">Kindly take a moment to tell us what you think.</label>
                        <textarea type="text" id="textarea" className={styles.input} placeholder='' rows={5} value={feedback} onChange={handleOnChangeFeedback}/>
                    </div>
                    <div className="mt-4">
                        <Button
                        disabled={rating === 0 || feedback === ""}
                        onClick={handleSubmitFeedback}
                        className="btn-horizontal-gradient 
                                    w-full 
                                    py-2 
                                    border-round-2xl 
                                    text-base
                                    align-items-center
                                    justify-content-center
                                    gap-2"
                        >
                        Submit Feedback
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SubmitFeedbackComp;